// removed by extract-text-webpack-plugin
module.exports = {"appContent":"_3PmV0Or225M5dpmCHcwSn7","container-page-registration-step":"_1yfvXF_vYIPFaTqzCPKPZG"};


//////////////////
// WEBPACK FOOTER
// ./shared/containers/App/style.scss
// module id = 988
// module chunks = 0